export const paypalUrlUtil = () => {
  return process.env.NEXT_PUBLIC_APP_ENV === 'prod'
    ? 'https://www.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token='
    : 'https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=';
};
